import { Flex } from '@chakra-ui/layout';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { DataPipelineList } from '~/packages/dataPipeline/ui/list/DataPipelineList';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return <DataPipelineList organizationId={user.organization.id} />;
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
